import Image from 'next/image'

import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

import TrustBox from '@components/TrustBox'

import UnscoredButton from '../UnscoredButton'
import { whyTotallyMoneySections } from './lib/whyTotallyMoneySections'

const WhyTotallyMoneySection = () => (
    <Stack gridColumn="1/13" space="space50">
        <Box
            display="grid"
            gridTemplateColumns={['1fr', 'repeat(3, 1fr)']}
            gridGap="space30"
        >
            {whyTotallyMoneySections.map(
                ({ heading, image: { alt, src }, text }, i) => (
                    <Flex justifyContent="center" key={`${heading}-${i}`}>
                        <Stack space="space20" maxWidth="282px">
                            <Flex justifyContent="center">
                                <Image
                                    alt={alt}
                                    src={src}
                                    width={96}
                                    height={96}
                                    sizes="96px"
                                    priority={false}
                                    placeholder="empty"
                                    quality={60}
                                />
                            </Flex>

                            <Heading variant="40" textAlign="center">
                                {heading}
                            </Heading>

                            <Text variant="100" textAlign="center">
                                {text}
                            </Text>
                        </Stack>
                    </Flex>
                )
            )}
        </Box>

        <Flex justifyContent="center" width="100%">
            <UnscoredButton />
        </Flex>

        <TrustBox />
    </Stack>
)

export default WhyTotallyMoneySection
